import React from 'react';
import { string, bool } from 'prop-types';
import { palette } from '@seaweb/coral/components/ThemeProvider';
import styled from 'styled-components';

const StyledText = styled.p`
  margin: auto;
  display: inline;
  em {
    color: ${palette.blue};
    font-style: normal;
    font-weight: bold;
  }

  ${(props) =>
    props.clamp
      ? `
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        `
      : ''}
`;

/**
 * Elasticsearch Higlighter
 * <em></em> is the default highlighting tag SOS is using right now
 * https://www.elastic.co/guide/en/elasticsearch/reference/6.8/search-request-highlighting.html#configure-tags
 * This component only accepts a string as the Elasticsearch result is always a string.
 * @param {*} text
 */
function ElkHighlighter({ text, clamp }) {
  return (
    <StyledText dangerouslySetInnerHTML={{ __html: text }} clamp={clamp} />
  );
}

ElkHighlighter.propTypes = {
  text: string.isRequired,
  clamp: bool,
};

export default ElkHighlighter;
